// removed by extract-text-webpack-plugin
module.exports = {"btn-icon":"BtnPrint-module-btn-icon-3coMR","btnIcon":"BtnPrint-module-btn-icon-3coMR","btn":"BtnPrint-module-btn-2iu1U","icon-print":"BtnPrint-module-icon-print-1wEbr","iconPrint":"BtnPrint-module-icon-print-1wEbr","btn-text":"BtnPrint-module-btn-text-2TJzt","btnText":"BtnPrint-module-btn-text-2TJzt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BtnPrint/BtnPrint.module.scss
// module id = 1125
// module chunks = 0